import { gql } from '@apollo/client';
import { Registration, UpdateRegistrationInput } from '../API';
import { getApolloClient } from '../apolloClient';

export const PARTY_FIELDS = gql`
  fragment CheckInParty on Registration {
    __typename eventId registrationId firstName lastName email live guests checkedInCount registrationStatus
    dateCreated additionalData submissionId attendanceTrackingMode partyVersion rosterVersion
    attendees { __typename attendeeId eventId registrationId role firstName lastName email displayOrder status isCheckedIn }
  }
`;
export const GET_PARTY = gql`query CheckInParty($eventId: String!, $registrationId: String!) {
  getRegistrationParty(eventId: $eventId, registrationId: $registrationId) { ...CheckInParty }
} ${PARTY_FIELDS}`;
export const LIST_PARTIES = gql`query CheckInParties($eventId: String!, $nextToken: String) {
  listRegistrationPartiesByEventId(eventId: $eventId, limit: 50, nextToken: $nextToken) {
    items { ...CheckInParty } nextToken
  }
} ${PARTY_FIELDS}`;
export const UPDATE_PARTY = gql`mutation CheckInAttendance($input: UpdateRegistrationInput!) {
  updateRegistration(input: $input) { ...CheckInParty }
} ${PARTY_FIELDS}`;
export const PARTY_CHANGED = gql`subscription CheckInPartyChanged($eventId: String!) {
  onRegistrationPartyChanged(eventId: $eventId) { eventId registrationId partyVersion deleted }
}`;
export async function getParty(eventId: string, registrationId: string): Promise<Registration | null> {
  const client = await getApolloClient();
  const { data } = await client.query<{ getRegistrationParty: Registration | null }>({ query: GET_PARTY, variables: { eventId, registrationId }, fetchPolicy: 'no-cache' });
  return data.getRegistrationParty;
}
export async function listParties(eventId: string): Promise<Registration[]> {
  const client = await getApolloClient();
  const parties: Registration[] = [];
  const cursors = new Set<string>();
  let nextToken: string | null = null;
  do {
    const { data } = await client.query<{ listRegistrationPartiesByEventId: { items: (Registration | null)[]; nextToken: string | null } }>({ query: LIST_PARTIES, variables: { eventId, nextToken }, fetchPolicy: 'no-cache' });
    const page = data.listRegistrationPartiesByEventId;
    if (!page) throw new Error('Unable to load parties. Refresh to retry.');
    parties.push(...(page.items ?? []).filter(Boolean));
    nextToken = page.nextToken;
    if (nextToken && cursors.has(nextToken)) throw new Error('Party pagination did not advance.');
    if (nextToken) cursors.add(nextToken);
  } while (nextToken);
  return parties;
}
export async function saveAttendance(input: UpdateRegistrationInput): Promise<Registration> {
  const client = await getApolloClient();
  const { data } = await client.mutate<{ updateRegistration: Registration }>({ mutation: UPDATE_PARTY, variables: { input } });
  if (!data?.updateRegistration) throw new Error('No attendance result was returned. Retry the same action.');
  return data.updateRegistration;
}
